import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/**
 * MS-CUSTOM: companion for blocks/stock.liquid.
 * Horizon only re-renders its own elements on variant change, so this swaps in the
 * freshly rendered block (quantity + in-range state) from the section HTML the
 * variant picker already fetched. Same pattern as assets/product-inventory.js.
 */
class StockRemaining extends HTMLElement {
  /** @type {Element | null} */
  #scope = null;

  connectedCallback() {
    this.#scope = this.closest('.shopify-section, dialog');
    this.#scope?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#scope?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#scope = null;
  }

  /** @param {any} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const blockId = CSS.escape(this.dataset.blockId ?? '');
        const next = html.querySelector(`stock-remaining[data-block-id="${blockId}"]`);
        if (!next) return;

        this.hidden = next.hidden;
        this.className = next.className;
        morph(this, next, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[stock-remaining] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('stock-remaining')) {
  customElements.define('stock-remaining', StockRemaining);
}
